import { useSetState } from './use-set-state.js';
import type { TooltipItem } from '../../../../core/types/tooltip.js';
import { useFormatter } from '../../../shared/context/FormatterContext.js';

export const useSetTooltipContent = () => {
  const { formatter } = useFormatter();
  const setState = useSetState();

  const setTooltipContent = (id: string) => {
    setState((prev) => {
      const segment = prev.visibleSegments.get(id);

      if (!segment) {
        return prev;
      }

      if (prev.tooltip.content?.id === segment.id) {
        return prev;
      }

      const content: TooltipItem = {
        name: segment.name,
        id: segment.id,
        color: { Default: segment.color },
        values: [formatter(segment.value)],
      };

      return { ...prev, tooltip: { ...prev.tooltip, content } };
    });
  };

  return {
    setTooltipContent,
  };
};
